export function isAbortError (error: unknown): boolean {
    if (typeof error !== 'object' || error === null || !('name' in error)) {
        return false;
    }
    return (error as { name: string }).name === 'AbortError';
}
